import { render, staticRenderFns } from "./VacancyPreview.vue?vue&type=template&id=1920d3ef&"
import script from "./VacancyPreview.vue?vue&type=script&lang=js&"
export * from "./VacancyPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports